import { createFileRoute } from "@tanstack/react-router";
import { DienstLocatiePage, dienstLocatieHead } from "../components/DienstLocatiePage";
import { kozijnenDordrecht } from "../lib/dienst-locatie-content";

export const Route = createFileRoute("/kozijnen-dordrecht")({
  head: () => dienstLocatieHead(kozijnenDordrecht),
  component: () => <DienstLocatiePage content={kozijnenDordrecht} />,
});
